import React, { useContext } from "react";
import PrintOrder from "./PrintOrder";
import { StateContext } from "../../../../components/context/StateProvider";
import { AVISO_TICKET_ALTURA, etiquetaAlturaActiva, filtrarProductosAltura } from "../../helpers/ubicacionesAltura";

// Cada etiqueta en su propia hoja: la de altura se recoge aparte del pedido completo
const sxSaltoPagina = { breakBefore: "page", pageBreakBefore: "always" };

/**
 * Lo que imprime el botón de etiqueta de Nave 2: el ticket de preparación completo y,
 * si el pedido o grupo mezcla productos en altura o Tronja 3 con otros que no lo están,
 * detrás una segunda etiqueta solo con los de altura (con el aviso AVISO_TICKET_ALTURA).
 * Si todos están en altura, o el flag REACT_APP_ETIQUETA_ALTURA está a "false", sale solo la normal. Sin props, igual que PrintOrder,
 * toma el pedido y los productos del contexto (el punteo abierto).
 *
 * DECISION: sustituye al botón aparte de "solo altura": una sola impresión saca las dos
 * etiquetas y no depende de que alguien se acuerde de pulsar el segundo botón.
 *
 * forwardRef NO es opcional: react-to-print recibe esta ref para localizar el nodo a
 * imprimir. Sin productos no hay nodo, como en PrintOrder.
 */
const TicketsPreparacion = React.forwardRef(({ order, products }, ref) => {
    const { state } = useContext(StateContext);
    const productos = products ?? state.products;
    const productosAltura = etiquetaAlturaActiva() ? filtrarProductosAltura(productos) : [];
    // Si todo está en altura, la segunda etiqueta repetiría la primera
    const separarAltura = productosAltura.length > 0 && productosAltura.length < productos.length;

    if (productos.length === 0) return null;

    return (
        <div ref={ref}>
            <PrintOrder order={order} products={productos} />
            {separarAltura && (
                <div style={sxSaltoPagina}>
                    <PrintOrder order={order} products={productosAltura} aviso={AVISO_TICKET_ALTURA} />
                </div>
            )}
        </div>
    );
});

TicketsPreparacion.displayName = "TicketsPreparacion";

export default TicketsPreparacion;
